export const products = [
  { id: "set1", name: "Makeup Experts Value Set",
    brand: "Sephora Favorites", category: "Variado",
    stock: false, isSet: true, totPz: 13 ,ss:true, 
    price: 2680, oldPrice: 2390,
    fullSizeCount: 6, miniSizeCount: 7, dlxSizeCount: 0,
    descriptionSet: "Imprescindibles de las mejores marcas como Patrick, O/S, Mario, Natasha, Huda y más",
    image: "https://www.sephora.com/productimages/sku/s3013422-main-zoom.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3013422-main-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3013422-av-3202606021447062130700-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3013422-av-1202606021447054770700-zoom.jpg?imwidth=1224"
    ]
  },
  { id: "set2", name: "Holiday Must Haves",
    brand: "Sephora Favorites", category: "Variado",
    stock: false, isSet: true, totPz: 9, ss:true, 
    price: 1870, oldPrice: 1690,
    fullSizeCount: 3, miniSizeCount: 6, dlxSizeCount: 0,
    descriptionSet: "Productos esenciales,marcas como Merit, Rare Beauty, Huda Beauty y más",
    image: "https://www.sephora.com/productimages/sku/s3013463-main-zoom.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3013463-main-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3013463-av-3-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3013463-av-1-zoom.jpg?imwidth=1224",
    ]
  },
  { id: "set3", name: "Holiday Lip Kit",
    brand: "Sephora Favorites", category: "Lippies",
    stock: true, isSet: true, totPz: 9 ,ss:true, 
    price: 1660, oldPrice: 1500,
    fullSizeCount: 5, miniSizeCount: 2, dlxSizeCount: 2,
    descriptionSet: "Luce unos labios perfectos estas fiestas. Marcas como Armani Beauty, Huda, Rare Beauty y más",
    image: "https://www.sephora.com/productimages/sku/s3013448-main-zoom.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3013448-main-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3013448-av-3-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3013448-av-1-zoom.jpg?imwidth=1224"
    ]
  },
  { id: "set4", name: "Cozy & Clean",
    brand: "Sephora Favorites", category: "Maquillaje",
    stock: false, isSet: true, totPz: 7 ,ss:true, 
    price: 1485, oldPrice: 1300,
    fullSizeCount: 3, miniSizeCount: 2, dlxSizeCount: 2,
    descriptionSet: "Productos de Ciele, Haus Labs, Kosas y más para realzar tu rutina de belleza.",
    image: "https://www.sephora.com/productimages/sku/s3013430-main-zoom.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3013430-main-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3013430-av-3-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3013430-av-1-zoom.jpg?imwidth=1224"
    ]
  },
  { id: "set5", name: "Mini Holiday Must-Haves",
    brand: "Sephora Favorites", category: "Variado",
    stock: true, isSet: true, totPz: 5 ,ss:true, 
    price: 880, oldPrice: 795,
    fullSizeCount: 1, miniSizeCount: 4, dlxSizeCount: 0,
    descriptionSet: "Incluye: Mini Blush Rare, Brow Setter Benefit,Serum Laneige,Mascara YSL & Patches ",
    image: "https://www.sephora.com/productimages/sku/s3013455-main-zoom.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3013455-main-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3013455-av-3-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3013455-av-1-zoom-1.jpg?imwidth=1224"
    ]
  },
  { id: "set6", name: "Holiday Perfume con cupón*",
    brand: "Sephora Favorites", category: "Perfumes",
    stock: false, isSet: true, totPz: 11 ,ss:true, 
    price: 2990, oldPrice: 2700,
    fullSizeCount: 0, miniSizeCount: 0, dlxSizeCount: 11,
    descriptionSet: "Minis de perfumes virales con voucher para cambiarlo por un full size a elegir de tu fragancia favorita.",
    image: "https://www.sephora.com/productimages/sku/s3025293-main-zoom.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3025293-main-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3025293-av-1-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3025293-av-2-zoom.jpg?imwidth=1224",
    ]
  },
  { id: "set7", name: "Mini Lip Trio Set",
    brand: "Gisou", category: "Lippies",
    stock: false, isSet: true, totPz: 3 ,ss:true, 
    price: 1040, oldPrice: 900,
    fullSizeCount: 0, miniSizeCount: 3, dlxSizeCount: 0,
    descriptionSet: "Edición límitada de tonos Raspberry Swirl, Strawberry Sorbet & Glazed Plum",
    image: "https://www.sephora.com/productimages/sku/s3015542-main-zoom-4.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3015542-main-zoom-4.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3015542-av-4-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3015542-av-3-zoom.jpg?imwidth=1224"
    ]
  },
  { id: "set8", name: "On 'Til Dawn Setting Sprays",
    brand: "One Size", category: "Maquillaje",
    stock: false, isSet: true, totPz: 2 ,ss:true, 
    price: 1290, oldPrice: 1110,
    fullSizeCount: 1, miniSizeCount: 1, dlxSizeCount: 0,
    descriptionSet: "Spray fijador matificante resistente al sudor,agua y manchas. ",
    image: "https://www.sephora.com/productimages/sku/s3022209-main-zoom-2.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3022209-main-zoom-2.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3022209-av-10-zoom.jpg?imwidth=1224",
    ]
  },
  { id: "set9", name: "The Lip Butter Balm - Pink Set",
    brand: "Summer Fridays", category: "Lippies",
    stock: false, isSet: true, totPz: 4 ,ss:true, 
    price: 890, oldPrice: 780,
    fullSizeCount: 0, miniSizeCount: 4, dlxSizeCount: 0,
    descriptionSet: "Minis Butter Balms. Tonos: Birthday Cake, Strawberry Soft Serve, Pink Guava, Cherry",
    image: "https://www.sephora.com/productimages/sku/s3023678-main-zoom-1.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3023678-main-zoom-1.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3023678-av-7-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3023678-av-5-zoom.jpg?imwidth=1224",
    ]
  },
  { id: "set10", name: "Marshmallow - Body & Lip",
    brand: "Summer Fridays", category: "Variado",
    stock: false, isSet: true, totPz: 3 ,ss:true, 
    price: 1050, oldPrice: 950,
    fullSizeCount: 0, miniSizeCount: 0, dlxSizeCount: 0,
    descriptionSet: "Incluye Body Butter Balm, Body Fragrance Mist & Lip Butter Balm.",
    image: "https://www.sephora.com/productimages/sku/s3023660-av-1-zoom.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3023660-av-1-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3023660-av-8-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3023660-main-zoom.jpg?imwidth=1224"
    ]
  },
  { id: "set11", name: "Hope Faves Set",
    brand: "Rare Beauty", category: "Maquillaje",
    stock: false, isSet: true, totPz:4, ss:true, 
    price: 1600, oldPrice: 1480,
    fullSizeCount: 2, miniSizeCount: 2, dlxSizeCount: 0,
    descriptionSet: "Indispensables en tono Hope para mejillas y labios, además de una mini puffy tote",
    image: "https://www.sephora.com/productimages/sku/s3014628-av-11-zoom-us.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3014628-av-11-zoom-us.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3014628-av-3-zoom-us.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3014628-av-5-zoom-us.jpg?imwidth=1224",
    ]
  },
  { id: "set12", name: "Pocket Pair Toasted teddy + Espresso",
    brand: "Rhode", category: "Maquillaje",
    stock: false, isSet: true, totPz: 2 ,ss:true, 
    price: 1200, oldPrice: 1040,
    fullSizeCount: 2, miniSizeCount: 0, dlxSizeCount: 0,
    descriptionSet: "Set de edición limitada que incluye Pocket Blush y Peptide Lip Tint",
    image: "https://www.sephora.com/productimages/sku/s3023264-main-zoom.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3023264-main-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s2895969-av-2202507250910054490700-zoom.jpg?imwidth=1224",
      "https://www.rhodeskin.com/cdn/shop/files/Mobile-EspressoGrid-1_640x.jpg?v=1762221035",
    ]
  },
  { id: "set13", name: "Sugarmint Trio Skincare Set",
    brand: "Rhode", category: "Skincare",
    stock: false, isSet: true, totPz: 3 ,ss:true, 
    price: 1830, oldPrice: 1630,
    fullSizeCount: 2, miniSizeCount: 1, dlxSizeCount: 0,
    descriptionSet: "Prepara la piel para maquillaje,reduce la hinchazón de ojos,hidrata la piel y da volumen a los labios.",
    image: "https://www.sephora.com/productimages/sku/s3025525-main-zoom.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3025525-main-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3025525-av-2-zoom.jpg?imwidth=1224",
    ]
  },
  { id: "set14", name: "Mini Dew Blush Trio",
    brand: "Saie", category: "Maquillaje",
    stock: false, isSet: true, totPz: 3 ,ss:true, 
    price: 980, oldPrice: 850,
    fullSizeCount: 0, miniSizeCount: 3, dlxSizeCount: 0,
    descriptionSet: "Mini Rubores (5.9ml) en tonos:  Cherie, Chilly, Lady",
    image: "https://www.sephora.com/productimages/sku/s3026283-av-1-zoom.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3026283-av-1-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3026283-av-2-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3026283-main-zoom.jpg?imwidth=1224"
    ]
  },
  { id: "set15", name: "Gleamy Dreamy",
    brand: "Sephora Favorites", category: "Variado",
    stock: false, isSet: true, totPz: 9 ,ss:true, 
    price: 1660, oldPrice: 1500,
    fullSizeCount: 3, miniSizeCount: 2, dlxSizeCount: 4,
    descriptionSet: "Esenciales para apariencia radiante,marcas como Milk Makeup, Haus Labs, Glow Recipe y más",
    image: "https://www.sephora.com/productimages/sku/s2996031-main-zoom.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s2996031-main-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s2996031-av-1202604081715586770700-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s2996031-av-3202604081716000220700-zoom.jpg?imwidth=1224"
    ]
  },
  { id: "set16", name: "Mauve Faves Lip Duo",
    brand: "Rare Beauty", category: "Lippies",
    stock: false, isSet: true, totPz: 2 ,ss:true, 
    price: 870, oldPrice: 700,
    fullSizeCount: 2, miniSizeCount: 0, dlxSizeCount: 0,
    descriptionSet: "Esenciales para labios en tonos de edición limitada.",
    image: "https://www.sephora.com/productimages/sku/s3014602-av-7-zoom-us.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3014602-av-7-zoom-us.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3014602-av-4-zoom-us.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3014602-av-3-zoom-us.jpg?imwidth=1224",
    ]
  },
  { id: "set17", name: "Something Spicy, Gingerbread Latte Duo",
    brand: "Patrick Ta", category: "Maquillaje",
    stock: false, isSet: true, totPz: 2 ,ss:true, 
    price: 1590, oldPrice: 1360,
    fullSizeCount: 2, miniSizeCount: 0, dlxSizeCount: 0,
    descriptionSet: "Set edición límitada Blush Duo & Lip Balm ",
    image: "https://www.sephora.com/productimages/sku/s3018561-av-1-zoom.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3018561-av-1-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3018561-av-3-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3018561-av-4-zoom.jpg?imwidth=1224",
    ]
  },
  { id: "set18", name: "Oil Sucker Prep & Refresh Duo",
    brand: "One Size", category: "Maquillaje",
    stock: false, isSet: true, totPz: 2 ,ss:true, 
    price: 1270, oldPrice: 1090,
    fullSizeCount: 1, miniSizeCount: 1, dlxSizeCount: 0,
    descriptionSet: "Controla el brillo y absorbe el exceso de grasa proporcionando acabado mate ultradifuminado.",
    image: "https://www.sephora.com/productimages/sku/s3022191-main-zoom-2.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3022191-main-zoom-2.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3022191-av-5-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3022191-av-8-zoom.jpg?imwidth=1224"
    ]
  },
  { id: "set19", name: "Something Sweet, Vanilla Chai Duo",
    brand: "Patrick Ta", category: "Maquillaje",
    stock: false, isSet: true, totPz: 2 ,ss:true, 
    price: 1590, oldPrice: 1360,
    fullSizeCount: 2, miniSizeCount: 0, dlxSizeCount: 0,
    descriptionSet: "Set edición límitada Blush Duo & Lip Balm",
    image: "https://www.sephora.com/productimages/sku/s3018603-av-1-zoom.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3018603-av-1-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3018603-av-3-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3018603-av-4-zoom.jpg?imwidth=1224",
    ]
  },
  { id: "set20", name: "Pocket Pair Sleepy girl + Pretzel",
    brand: "Rhode", category: "Maquillaje",
    stock: false, isSet: true, totPz: 2, ss:true, 
    price: 1200, oldPrice: 1040,
    fullSizeCount: 2, miniSizeCount: 0, dlxSizeCount: 0,
    descriptionSet: "Set de edición limitada que incluye Pocket Blush y Peptide Lip Tint",
    image: "https://www.sephora.com/productimages/sku/s3023272-main-zoom.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3023272-main-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s2895845-av-2202507250642211930700-zoom.jpg?imwidth=1224",
      "https://www.rhodeskin.com/cdn/shop/files/pretzel-hero3-4grid-mobile_22f5fc68-cd1d-4b92-8b25-a02997b08b11_640x.jpg?v=1790629871"
    ]
  },
  { id: "set21", name: "Pocket Pair Sprinkle + Ribbon ",
    brand: "Rhode", category: "Maquillaje",
    stock: false, isSet: true, totPz: 2, ss:true, 
    price: 1200, oldPrice: 1040,
    fullSizeCount: 2, miniSizeCount: 0, dlxSizeCount: 0,
    descriptionSet: "Set de edición limitada que incluye Pocket Blush y Peptide Lip Tint",
    image: "https://www.sephora.com/productimages/sku/s3023280-main-zoom.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3023280-main-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s2896033-av-2202508150822392870700-zoom.jpg?imwidth=1224",
      "https://www.rhodeskin.com/cdn/shop/files/Mobile-RibbonGrid-1_5112626c-a659-447d-bde7-b24e60b87cd4_960x.jpg?v=1762221133"
    ]
  },
  { id: "set22", name: "Solstice Duo ",
    brand: "Refy", category: "Maquillaje",
    stock: false, isSet: true, totPz: 2 ,ss:true, 
    price: 1040, oldPrice: 920,
    fullSizeCount: 2, miniSizeCount: 0, dlxSizeCount: 0,
    descriptionSet: "Shimmer Lip Gloss & Highlighter en tono solstice",
    image: "https://www.sephora.com/productimages/sku/s3028040-main-zoom.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3028040-main-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3028040-av-7-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3028040-av-3-zoom.jpg?imwidth=1224"
    ]
  },
  { id: "set23", name: "Gaia Duo",
    brand: "Refy", category: "Maquillaje",
    stock: false, isSet: true, totPz: 2 ,ss:true, 
    price: 1040, oldPrice: 920,
    fullSizeCount: 2, miniSizeCount: 0, dlxSizeCount: 0,
    descriptionSet: "Shimmer Lip Gloss & Highlighter en tono gaia",
    image: "https://www.sephora.com/productimages/sku/s3028016-main-zoom.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3028016-main-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3028016-av-7-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3028016-av-3-zoom.jpg?imwidth=1224"
    ]
  },
  { id: "set24", name: "Tinted Lip Balm Trio",
    brand: "Patrick Ta", category: "Lippies",
    stock: false, isSet: true, totPz: 3 ,ss:true, 
    price: 990, oldPrice: 860,
    fullSizeCount: 0, miniSizeCount: 3, dlxSizeCount: 0,
    descriptionSet: "Must-have minis: Espresso, Cookie Butter, and Mint Mocha.",
    image: "https://www.sephora.com/productimages/sku/s3018587-main-zoom.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3018587-main-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3018587-av-2-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3018587-av-3-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3018587-av-4-zoom.jpg?imwidth=1224"
    ]
  },
  { id: "set25", name: "Mini Lip Gloss Trio ",
    brand: "Refy", category: "Lippies",
    stock: false, isSet: true, totPz: 3 ,ss:true, 
    price: 990, oldPrice: 880,
    fullSizeCount: 0, miniSizeCount: 3, dlxSizeCount: 0,
    descriptionSet: "Tres mini gloss ideales para llevar a todos lados",
    image: "https://www.sephora.com/productimages/sku/s3028065-main-zoom.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3028065-main-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3028065-av-3-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3028065-av-5-zoom.jpg?imwidth=1224"
    ]
  },
  { id: "set26", name: "Eye and Cheek Set MERIT x Erdem",
    brand: "Merit", category: "Maquillaje",
    stock: false, isSet: true, totPz: 4 ,ss:true, 
    price: 1995, oldPrice: 1780,
    fullSizeCount: 2, miniSizeCount: 2, dlxSizeCount: 0,
    descriptionSet: "Set edición límitada tonos: Flush Balm(Carnation), Day glow(Tulle), Shadow(Mink) y Mascara",
    image: "https://www.sephora.com/productimages/sku/s3003191-av-1-zoom.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3003191-av-1-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3003191-av-2-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3003191-av-7-zoom.jpg?imwidth=1224"
    ]
  },
  { id: "set27", name: "Signature Lip Set MERIT x Erdem ",
    brand: "Merit", category: "Lippies",
    stock: false, isSet: true, totPz: 3 ,ss:true, 
    price: 1890, oldPrice: 1650,
    fullSizeCount: 3, miniSizeCount: 3, dlxSizeCount: 0,
    descriptionSet: "Signature Lip Matte tonos Black Tie, London y Bespoke",
    image: "https://www.sephora.com/productimages/sku/s3003183-av-1-zoom.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3003183-av-3-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3003183-av-5-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3003183-av-4-zoom.jpg?imwidth=1224",
    ]
  },
  { id: "set28", name: "Athena Club Holiday",
    brand: "Athena Club", category: "Varios",
    stock: false, isSet: true, totPz: 0 ,ss:false, 
    price: 640, oldPrice: 0,
    fullSizeCount: 0, miniSizeCount: 0, dlxSizeCount: 0,
    descriptionSet: "Mini mist, Desodorante Golden Vanilla,  Kit de afeitado y aceite",
    image: "https://target.scene7.com/is/image/Target/GUEST_1a6e87a6-3d21-49c4-a6ce-2029c6a9b0c4?wid=1000&hei=1000&qlt=80&fmt=webp",
    setImages: [
      "https://target.scene7.com/is/image/Target/GUEST_1a6e87a6-3d21-49c4-a6ce-2029c6a9b0c4?wid=1000&hei=1000&qlt=80&fmt=webp",
      "https://target.scene7.com/is/image/Target/GUEST_6f21f96f-db04-41f2-bd26-2029a230a0ef?wid=1000&hei=1000&qlt=80&fmt=webp",
      "https://target.scene7.com/is/image/Target/GUEST_796aa703-d1a1-4341-98c0-0724acf304db?wid=1000&hei=1000&qlt=80&fmt=webp"
    ]
  },
  { id: "set29", name: "Jell-o x Tower 28 Lil' Pudding",
    brand: "Tower 28", category: "lippies",
    stock: false, isSet: true, totPz: 4 ,ss:true, 
    price: 770, oldPrice: 690,
    fullSizeCount: 0, miniSizeCount: 4, dlxSizeCount: 0,
    descriptionSet: "Tonos:  Pistachio, Strawberry Cheesecake, Chocolate Vanilla Swirl, Banana Cream",
    image: "https://www.sephora.com/productimages/sku/s3026234-main-zoom.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3026234-main-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3026234-av-1-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3026234-av-7-zoom.jpg?imwidth=1224"
    ]
  },
  { id: "set30", name: "SOS Stressed Skin Minis",
    brand: "Tower 28", category: "Skincare",
    stock: false, isSet: true, totPz: 5 ,ss:true, 
    price: 950, oldPrice: 820,
    fullSizeCount: 0, miniSizeCount: 5, dlxSizeCount: 0,
    descriptionSet: "Rutina de 4 pasos que limpia, calma e hidrata.",
    image: "https://www.sephora.com/productimages/sku/s3025954-main-zoom.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3025954-main-zoom.jpg?imwidth=1224",
      "https://www.tower28beauty.com/cdn/shop/files/3025954-av-1.jpg?v=1790271686&width=1800",
    ]
  },
  { id: "set31", name: "Blush Veil & Skin Enhancer Duo",
    brand: "Makeup by Mario", category: "Maquillaje",
    stock: false, isSet: true, totPz: 1 ,ss:true, 
    price: 980, oldPrice: 860,
    fullSizeCount: 0, miniSizeCount: 1, dlxSizeCount: 0,
    descriptionSet: "Estuche compacto que incluye los bálsamos de rubor y bronceador con acabado luminoso",
    image: "https://www.sephora.com/productimages/sku/s3019478-av-3-zoom.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3019478-av-3-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3019478-av-2-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3019478-main-zoom.jpg?imwidth=1224"
    ]
  },
  { id: "set32", name: "Bright Nights Hand Sanitizer + case",
    brand: "Touchland", category: "Variado",
    stock: false, isSet: true, totPz: 3 ,ss:true, 
    price: 960, oldPrice: 810,
    fullSizeCount: 3, miniSizeCount: 0, dlxSizeCount: 0,
    descriptionSet: "Mist Midnights s´mores, mist Cranberry fizz & Case Golden",
    image: "https://www.sephora.com/productimages/sku/s3022985-av-1-zoom.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3022985-av-1-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3022985-av-2-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3022985-main-zoom.jpg?imwidth=1224"
    ]
  },
  { id: "set33", name: "The All-Star Power Mist Hand Sanitizer",
    brand: "Touchland", category: "Variado",
    stock: false, isSet: true, totPz: 5 ,ss:true, 
    price: 1650, oldPrice: 1480,
    fullSizeCount: 5, miniSizeCount: 0, dlxSizeCount: 0,
    descriptionSet: "Coleccion Aromas Wild Watermelon, Berry Bliss, Vanilla Blossom, Blue Sandalwood, Beach Coco",
    image: "https://www.sephora.com/productimages/sku/s3022969-av-1-zoom.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3022969-av-1-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3022969-av-2-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3022969-main-zoom.jpg?imwidth=1224"
    ]
  },
  { id: "set34", name: "Sculpt & Pop On-The-Go",
    brand: "Makeup by Mario", category: "Maquillaje",
    stock: false, isSet: true, totPz: 2 ,ss:true, 
    price: 980, oldPrice: 860,
    fullSizeCount: 0, miniSizeCount: 2, dlxSizeCount: 0,
    descriptionSet: "Contorno y blush para un look impecable perfecto en cualquier momento y lugar.",
    image: "https://www.sephora.com/productimages/sku/s2809804-main-zoom.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s2809804-main-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s2809804-av-33-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s2809804-av-04-zoom.jpg?imwidth=1224"
    ]
  },
  { id: "set35", name: "Mini Lip Pulse Plumper",
    brand: "Kosas", category: "Lippies",
    stock: false, isSet: true, totPz: 3 ,ss:true, 
    price: 750, oldPrice: 640,
    fullSizeCount: 0, miniSizeCount: 3, dlxSizeCount: 0,
    descriptionSet: "Voluminizadores de labios con un ligero cosquilleo para labios visiblemente más voluminosos y brillantes.",
    image: "https://www.sephora.com/productimages/sku/s3023751-av-1-zoom.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3023751-av-1-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3023751-av-2-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3023751-main-zoom-1.jpg?imwidth=1224"
    ]
  },
  { id: "set36", name: "Jell-o x Tower 28 Lip Jelly ",
    brand: "Tower 28", category: "Skincare",
    stock: false, isSet: true, totPz: 2 ,ss:true, 
    price: 850, oldPrice: 760,
    fullSizeCount: 2, miniSizeCount: 0, dlxSizeCount: 0,
    descriptionSet: "Lip Jelly aroma Strawberry & Lemon-Lime",
    image: "https://www.sephora.com/productimages/sku/s3026242-main-zoom.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3026242-main-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3026242-av-5-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3026242-av-2-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3026242-av-3-zoom.jpg?imwidth=1224"
    ]
  },
  { id: "set37", name: "Glowy Super™ Gel Set",
    brand: "Saie", category: "Maquillaje",
    stock: false, isSet: true, totPz: 2 ,ss:true, 
    price: 960, oldPrice: 830,
    fullSizeCount: 1, miniSizeCount: 1, dlxSizeCount: 0,
    descriptionSet: "Incluye iluminadores Glowy Super Gel para una piel hidratada y radiante. ",
    image: "https://www.sephora.com/productimages/sku/s3026275-main-zoom.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3026275-main-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3026275-av-1-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3026275-av-2-zoom.jpg?imwidth=1224"
    ]
  },
  { id: "set38", name: "Watermelon Essentials Gift ",
    brand: "Glow Recipe", category: "Skincare",
    stock: false, isSet: true, totPz: 4 ,ss:true, 
    price: 1640, oldPrice: 1430,
    fullSizeCount: 0, miniSizeCount: 4, dlxSizeCount: 0,
    descriptionSet: "Rutina de cuidado de 4 pasos a base de sandía para una piel más suave",
    image: "https://www.sephora.com/productimages/sku/s3023439-main-zoom.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3023439-main-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3023439-av-11-zoom.jpg?imwidth=1224",
    ]
  },
  { id: "set39", name: "Spritz & Sol Cheirosa",
    brand: "Sol de Janeiro", category: "Perfumes",
    stock: false, isSet: true, totPz: 5 ,ss:true, 
    price: 1540, oldPrice: 1260,
    fullSizeCount: 0, miniSizeCount: 5, dlxSizeCount: 0,
    descriptionSet: "Cheirosa 62, 91, 59, 40 y 48 ",
    image: "https://www.sephora.com/productimages/sku/s3012390-av-1-zoom.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3012390-av-1-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3012390-av-2-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3012390-main-zoom.jpg?imwidth=1224"
    ]
  },
  { id: "set40", name: "Bright Eyes & Slick Lips Kit",
    brand: "Tropicals", category: "Variado",
    stock: false, isSet: true, totPz: 4 ,ss:true, 
    price: 920, oldPrice: 790,
    fullSizeCount: 0, miniSizeCount: 0, dlxSizeCount: 0,
    descriptionSet: "Bálsamo y mascarilla para ojos que hidrata los labios e ilumina el contorno de los ojos",
    image: "https://www.sephora.com/productimages/sku/s3028438-main-zoom-1.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3028438-main-zoom-1.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3028438-av-1-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3028438-av-2-zoom.jpg?imwidth=1224"
    ]
  },
  { id: "set41", name: "The Body Mist Edit",
    brand: "Phlur", category: "Perfumes",
    stock: true, isSet: true, totPz: 5 ,ss:true, 
    price: 1380, oldPrice: 0,
    fullSizeCount: 0, miniSizeCount: 5, dlxSizeCount: 0,
    descriptionSet: "Aromas: Vanilla Skin, Heavy Cream, Matcha Milk, Beach Skin & Paradise Nectar",
    image: "https://www.sephora.com/productimages/sku/s3026515-main-zoom.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3026515-main-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3026515-av-1-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3026515-av-2-zoom.jpg?imwidth=1224"
    ]
  },
  { id: "set42", name: "Mini Deodorant Discovery",
    brand: "Salt & Stone", category: "Variado",
    stock: false, isSet: true, totPz: 3 ,ss:true, 
    price: 960, oldPrice: 850,
    fullSizeCount: 0, miniSizeCount: 3, dlxSizeCount: 0,
    descriptionSet: "Desodorante sin aluminio, con niacinamida ",
    image: "https://www.sephora.com/productimages/sku/s3010238-main-zoom-1.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3010238-main-zoom-1.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3010238-av-3-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3010238-av-9-zoom.jpg?imwidth=1224"
    ]
  },
  { id: "set43", name: "Insatiable Liquid Blush Duo",
    brand: "Nars", category: "Maquillaje",
    stock: false, isSet: true, totPz: 2 ,ss:true, 
    price: 980, oldPrice: 860,
    fullSizeCount: 0, miniSizeCount: 2, dlxSizeCount: 0,
    descriptionSet: "Tonos All Access & Worship",
    image: "https://www.sephora.com/productimages/sku/s3027653-main-zoom.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3027653-main-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3027653-av-2-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3027653-av-1-zoom.jpg?imwidth=1224"
    ]
  },
  { id: "set44", name: "Honey Gloss Hair Therapy Set",
    brand: "Gisou", category: "Variado",
    stock: false, isSet: true, totPz: 4 ,ss:true, 
    price: 2450, oldPrice: 2100,
    fullSizeCount: 1, miniSizeCount: 3, dlxSizeCount: 0,
    descriptionSet: "Incluye champú,acondicionador,aceite capilar y full mascarilla capilar ",
    image: "https://www.sephora.com/productimages/sku/s3015526-av-2-zoom.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3015526-av-2-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3015526-av-1-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3015526-main-zoom-1.jpg?imwidth=1224"
    ]
  },
  { id: "set45", name: "Soulgazer Eye-intensifying",
    brand: "Kosas", category: "Maquillake",
    stock: false, isSet: true, totPz: 3 ,ss:true, 
    price: 1090, oldPrice: 970,
    fullSizeCount: 2, miniSizeCount: 1, dlxSizeCount: 0,
    descriptionSet: "Set de rimel y delineador ideal para llevar a todas partes",
    image: "https://www.sephora.com/productimages/sku/s3023744-av-10-zoom.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3023744-av-10-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3023744-av-1-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3023744-av-2-zoom.jpg?imwidth=1224"
    ]
  },
  { id: "set46", name: "Violet Faves",
    brand: "Rare Beauty", category: "Maquillaje",
    stock: false, isSet: true, totPz: 3 ,ss:true, 
    price: 1020, oldPrice: 960,
    fullSizeCount: 0, miniSizeCount: 3, dlxSizeCount: 0,
    descriptionSet: "Minis para ruborizar, iluminar y dar brillo a tus labios sobre la marcha",
    image: "https://www.sephora.com/productimages/sku/s3014594-av-7-zoom.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3014594-av-7-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3014594-av-4-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3014594-av-5-zoom.jpg?imwidth=1224",
    ]
  },
  { id: "set47", name: "Rosa & Shine Fragance Duo",
    brand: "Sol de Janeiro", category: "Perfumes",
    stock: false, isSet: true, totPz: 2 ,ss:true, 
    price: 780, oldPrice: 690,
    fullSizeCount: 1, miniSizeCount: 1, dlxSizeCount: 0,
    descriptionSet: "75ml Rosa Charmosa Cream & 30ml Cheirosa 91",
    image: "https://www.sephora.com/productimages/sku/s3023025-av-2-zoom.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3023025-av-2-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3023025-av-4-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3023025-main-zoom.jpg?imwidth=1224"
    ]
  },
  { id: "set48", name: "Cactus 3-in-1 Styling Cream",
    brand: "Dae", category: "Variado",
    stock: false, isSet: true, totPz: 3 ,ss:true, 
    price: 820, oldPrice: 750,
    fullSizeCount: 0, miniSizeCount: 3, dlxSizeCount: 0,
    descriptionSet: "Controla el encrespamiento y el cabello rebelde a la vez que le das brillo al instante",
    image: "https://www.sephora.com/productimages/sku/s3024734-main-zoom.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3024734-main-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3024734-av-4-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3024734-av-5-zoom.jpg?imwidth=1224"
    ]
  },
  { id: "set49", name: "Bundle up Styling Kit",
    brand: "Dae", category: "Variado",
    stock: false, isSet: true, totPz: 4 ,ss:true, 
    price: 1450, oldPrice: 1270,
    fullSizeCount: 1, miniSizeCount: 3, dlxSizeCount: 0,
    descriptionSet: "Styling Cream(148ml), Hair Oil(50ml), Texturizing Spray(195ml), Peine",
    image: "https://www.sephora.com/productimages/sku/s3024718-av-1-zoom.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3024718-av-1-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3024718-av-3-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3024718-main-zoom.jpg?imwidth=1224"
    ]
  },
  { id: "set50", name: "Blushin' In Diamonds Set",
    brand: "Fenty Beauty", category: "Makeup",
    stock: false, isSet: true, totPz: 2 ,ss:true, 
    price: 1000, oldPrice: 900,
    fullSizeCount: 1, miniSizeCount: 1, dlxSizeCount: 0,
    descriptionSet: "Shake 'N Play Blush (Quit Wine’in) y Mini Diamond Bomb (How Many Carats?!)",
    image: "https://www.sephora.com/productimages/sku/s3018629-main-zoom.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3018629-main-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3018629-av-3-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3018629-av-2-zoom-1.jpg?imwidth=1224",
    ]
  },
  { id: "set51", name: "Berry Brown'd Pout Duo",
    brand: "Fenty Beauty", category: "Lippies",
    stock: false, isSet: true, totPz: 2 ,ss:true, 
    price: 750, oldPrice: 690,
    fullSizeCount: 2, miniSizeCount: 0, dlxSizeCount: 0,
    descriptionSet: "Lip Liner tono Brown'd Out, Gloss Bomb Stix tono Black'r Berry & Sacapuntas ",
    image: "https://www.sephora.com/productimages/sku/s3013372-main-zoom.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3013372-main-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3013372-av-7202605071642537330700-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3013372-av-1202605071642523390700-zoom.jpg?imwidth=1224"
    ]
  },
  { id: "set52", name: "Glossy Posse IX",
    brand: "Fenty Beauty", category: "Lippies",
    stock: false, isSet: true, totPz: 4,ss:true, 
    price: 1480, oldPrice: 1360,
    fullSizeCount: 3, miniSizeCount: 1, dlxSizeCount: 0,
    descriptionSet: "Luminizer(Chocolit Honey), Heat(Hawt Peach),Oil(Wine Stain) y Liner(Extra Thigh)",
    image: "https://www.sephora.com/productimages/sku/s3018660-main-zoom.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3018660-main-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3018660-av-2-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3018660-av-3-zoom-1.jpg?imwidth=1224",
    ]
  },
  { id: "set53", name: "Jet Set",
    brand: "Sol de Janeiro", category: "Perfume",
    stock: false, isSet: true, totPz: 3 ,ss:true, 
    price: 980, oldPrice: 820,
    fullSizeCount: 0, miniSizeCount: 3, dlxSizeCount: 0,
    descriptionSet: "Aromas Cheirosa 62, 68, 40 & 59",
    image: "https://i.pinimg.com/1200x/29/a7/5c/29a75cae04abf045d606a4ef29ab5e7e.jpg",
    setImages: [
    "https://i.pinimg.com/1200x/29/a7/5c/29a75cae04abf045d606a4ef29ab5e7e.jpg",
    "https://www.sephora.com/productimages/sku/s2205417-av-2202509301420159670700-zoom.jpg?imwidth=1224",
    ]
  },
  { id: "set54", name: "Bestsellers - Purr + Sleep + Debloat",
    brand: "Lemme", category: "Variado",
    stock: false, isSet: true, totPz: 3 ,ss:false, 
    price: 780, oldPrice: 0,
    fullSizeCount: 0, miniSizeCount: 3, dlxSizeCount: 0,
    descriptionSet: "Incluye Purr,Sleep y Debloat para favorecer salud vaginal, sueño reparador y digestión saludable.",
    image: "https://target.scene7.com/is/image/Target/GUEST_22eed408-e405-4c1f-a5d7-422772c91904?wid=1000&hei=1000&qlt=80&fmt=webp",
    setImages: [
      "https://target.scene7.com/is/image/Target/GUEST_22eed408-e405-4c1f-a5d7-422772c91904?wid=1000&hei=1000&qlt=80&fmt=webp",
      "https://target.scene7.com/is/image/Target/GUEST_60dbd4ac-873c-4cd6-88f8-0484e071af2c?wid=1000&hei=1000&qlt=80&fmt=webp",
      "https://target.scene7.com/is/image/Target/GUEST_d708c045-897e-4217-84d7-ca3149c7e940?wid=1000&hei=1000&qlt=80&fmt=webp",
    ]
  },
  { id: "set55", name: "Everyday Duo - Multi + Purr",
    brand: "Lemme", category: "Variado",
    stock: false, isSet: true, totPz: 2 ,ss:false, 
    price: 570, oldPrice: 0,
    fullSizeCount: 0, miniSizeCount: 2, dlxSizeCount: 0,
    descriptionSet: "Multi para nutrición y bienestar integral & Purr probióticos para salud vaginal. Paq. con 14pz",
    image: "https://target.scene7.com/is/image/Target/GUEST_3d10f437-e69b-4af2-8ecd-88f3a298389f?wid=1000&hei=1000&qlt=80&fmt=webp",
    setImages: [
    "https://target.scene7.com/is/image/Target/GUEST_3d10f437-e69b-4af2-8ecd-88f3a298389f?wid=1000&hei=1000&qlt=80&fmt=webp",
    "https://target.scene7.com/is/image/Target/GUEST_002a42b9-cd6b-4810-b0ed-c38f143ea964?wid=1000&hei=1000&qlt=80&fmt=webp",
    "https://target.scene7.com/is/image/Target/GUEST_076d4333-d6c3-4b3d-be9b-ea2efd5c0a36?wid=1000&hei=1000&qlt=80&fmt=webp",
    ]
  },
  { id: "set56", name: "Relax Chews Holiday Ornament",
    brand: "Lemme", category: "Variado",
    stock: false, isSet: true, totPz: 7 ,ss:false, 
    price: 300, oldPrice: 0,
    fullSizeCount: 0, miniSizeCount: 0, dlxSizeCount: 0,
    descriptionSet: "Adorno navideño masticable con magnesio, ashwagandha, L-teanina y cereza ácida",
    image: "https://target.scene7.com/is/image/Target/GUEST_7082fae2-8a8f-4a4f-bf2a-07ee9c80fed5?wid=1200&hei=1200&qlt=80",
    setImages: [
    "https://target.scene7.com/is/image/Target/GUEST_7082fae2-8a8f-4a4f-bf2a-07ee9c80fed5?wid=1200&hei=1200&qlt=80",
    "https://target.scene7.com/is/image/Target/GUEST_44466f50-484f-4cb7-8b98-95e17a13464a?wid=1000&hei=1000&qlt=80&fmt=webp",
    "https://target.scene7.com/is/image/Target/GUEST_a39c1ff8-3b59-422f-bae6-fed08e6ce880?wid=1000&hei=1000&qlt=80&fmt=webp",
    ]
  },
  { id: "set57", name: "Holiday Advent Calendar - Daise",
    brand: "Daise", category: "Calendarios",
    stock: false, isSet: true, totPz: 8,ss:false, 
    price: 960, oldPrice: 0,
    fullSizeCount: 0, miniSizeCount: 0, dlxSizeCount: 0,
    descriptionSet: "Incluye body mist con charms, bombas para baño, bálsamos & más",
    image: "https://target.scene7.com/is/image/Target/GUEST_6afb3f19-03c6-46ec-9ef7-21f5f7ecd4c5?wid=1000&hei=1000&qlt=80&fmt=webp",
    setImages: [
    "https://target.scene7.com/is/image/Target/GUEST_6afb3f19-03c6-46ec-9ef7-21f5f7ecd4c5?wid=1000&hei=1000&qlt=80&fmt=webp",
    "https://target.scene7.com/is/image/Target/GUEST_d88e5a05-9000-4f39-b27a-69172cbe77b3?wid=1000&hei=1000&qlt=80&fmt=webp",
    "https://i.pinimg.com/736x/de/81/af/de81af80695bb49c2fc02375510c4f5f.jpg",
    
  ]
  },
  { id: "set58", name: "Scent Advent Calendar",
    brand: "", category: "Calendarios",
    stock: false, isSet: true, totPz: 12,ss:false, 
    price: 850, oldPrice: 0,
    fullSizeCount: 0, miniSizeCount: 0, dlxSizeCount: 0,
    descriptionSet: "Incluye marcas como Athena Club, Saltair, Daise, Dossier, Cremerie Beauty, Eos & más",
    image: "https://target.scene7.com/is/image/Target/GUEST_136eb74d-e904-4d59-83d9-3b5315b4e456?wid=1000&hei=1000&qlt=80&fmt=webp",
    setImages: [
    "https://target.scene7.com/is/image/Target/GUEST_136eb74d-e904-4d59-83d9-3b5315b4e456?wid=1000&hei=1000&qlt=80&fmt=webp",
    "https://target.scene7.com/is/image/Target/GUEST_978463a3-cab1-45de-9673-e024334a7710?wid=1000&hei=1000&qlt=80&fmt=webp",
    "https://target.scene7.com/is/image/Target/GUEST_b12b8d8f-89d1-4a8d-8746-52f88e616a9d?wid=1000&hei=1000&qlt=80&fmt=webp",
    ]
  },
  { id: "set59", name: "Beauty Advent Calendar",
    brand: "", category: "Calendarios",
    stock: false, isSet: true, totPz: 12, ss:false, 
    price: 850, oldPrice: 0,
    fullSizeCount: 0, miniSizeCount: 0, dlxSizeCount: 0,
    descriptionSet: "Incluye productos marcas como elf, Lemme, Supergoop!, Essence & más",
    image: "https://target.scene7.com/is/image/Target/GUEST_42239e96-8644-46f0-afac-0919a6a18364?wid=1000&hei=1000&qlt=80&fmt=webp",
    setImages: [
    "https://target.scene7.com/is/image/Target/GUEST_42239e96-8644-46f0-afac-0919a6a18364?wid=1000&hei=1000&qlt=80&fmt=webp",
    "https://target.scene7.com/is/image/Target/GUEST_a3f2aad1-ed8e-4ac1-b693-548deb0da4fd?wid=1000&hei=1000&qlt=80&fmt=webp",
    "https://target.scene7.com/is/image/Target/GUEST_c2b03046-74f3-4c28-b6ba-183ab3d3e541?wid=1000&hei=1000&qlt=80&fmt=webp",
    ]
  },
  { id: "set60", name: "Skincare Advent Calendar",
    brand: "", category: "Calendarios",
    stock: false, isSet: true, totPz: 12, ss:false, 
    price: 850, oldPrice: 0,
    fullSizeCount: 0, miniSizeCount: 0, dlxSizeCount: 0,
    descriptionSet: "Incluye marcas como Byoma, Tonymoly, La Roche Posay, Good Molecules & más ",
    image: "https://target.scene7.com/is/image/Target/GUEST_e39f2aa1-5100-4463-829d-efb777a46284?wid=1000&hei=1000&qlt=80&fmt=webp",
    setImages: [
    "https://target.scene7.com/is/image/Target/GUEST_e39f2aa1-5100-4463-829d-efb777a46284?wid=1000&hei=1000&qlt=80&fmt=webp",
    "https://target.scene7.com/is/image/Target/GUEST_a285d78a-2e0b-4b15-b8bc-744825911acf?wid=1000&hei=1000&qlt=80&fmt=webp",
    "https://target.scene7.com/is/image/Target/GUEST_cd2f6653-c4db-41da-936a-405fbe68c24f?wid=1000&hei=1000&qlt=80&fmt=webp",
    ]
  },
  { id: "set61", name: "Spa Advent Calendar",
    brand: "", category: "Calendarios",
    stock: false, isSet: true, totPz: 12,ss:false, 
    price: 850, oldPrice: 0,
    fullSizeCount: 0, miniSizeCount: 0, dlxSizeCount: 0,
    descriptionSet: "Incluye marcas como: Pixi, Aquaphor, Avéne, Hero & más",
    image: "https://target.scene7.com/is/image/Target/GUEST_aa6fd6fa-ebf0-473e-b970-80a08baebfdd?wid=1000&hei=1000&qlt=80&fmt=webp",
    setImages: [
    "https://target.scene7.com/is/image/Target/GUEST_aa6fd6fa-ebf0-473e-b970-80a08baebfdd?wid=1000&hei=1000&qlt=80&fmt=webp",
    "https://target.scene7.com/is/image/Target/GUEST_b3f37303-c215-43b1-9dd6-ebba06d3f7aa?wid=1000&hei=1000&qlt=80&fmt=webp",
    "https://target.scene7.com/is/image/Target/GUEST_18ed7a49-7be9-49d7-85e2-890a3fd99981?wid=1000&hei=1000&qlt=80&fmt=webp",
    ]
  },
  { id: "set62", name: "Mini Mist Trio ",
    brand: "Daise", category: "Perfumes",
    stock: false, isSet: true, totPz: 3,ss:false, 
    price: 580, oldPrice: 0,
    fullSizeCount: 0, miniSizeCount: 3, dlxSizeCount: 0,
    descriptionSet: "Incluye 3 minis Sunny, Hello & Glaze",
    image: "https://target.scene7.com/is/image/Target/GUEST_86a3f919-e960-4330-a0ad-08ff5e9426b1?wid=1000&hei=1000&qlt=80&fmt=webp",
    setImages: [
    "https://target.scene7.com/is/image/Target/GUEST_86a3f919-e960-4330-a0ad-08ff5e9426b1?wid=1000&hei=1000&qlt=80&fmt=webp",
    "https://target.scene7.com/is/image/Target/GUEST_5a6e7c32-97a1-4bae-8dce-4dead2bb436b?wid=1000&hei=1000&qlt=80&fmt=webp",
    "https://target.scene7.com/is/image/Target/GUEST_867538a7-414b-45ef-bdb8-2f5a79db13ce?wid=1000&hei=1000&qlt=80&fmt=webp",
    ]
  },
  { id: "set63", name: "Set Hydro-Star Yellow + Clear",
    brand: "Starface", category: "Skincare",
    stock: false, isSet: true, totPz: 32,ss:false, 
    price: 360, oldPrice: 0,
    fullSizeCount: 0, miniSizeCount: 0, dlxSizeCount: 0,
    descriptionSet: "16 en tono amarillo y 16 en tono transparente ",
    image: "https://target.scene7.com/is/image/Target/GUEST_bbc09523-803c-48f6-8e99-8f8cccfe631a?wid=1000&hei=1000&qlt=80&fmt=webp",
    setImages: [
    "https://target.scene7.com/is/image/Target/GUEST_bbc09523-803c-48f6-8e99-8f8cccfe631a?wid=1000&hei=1000&qlt=80&fmt=webp",
    "https://target.scene7.com/is/image/Target/GUEST_80207bb4-ea11-4e92-9009-feee79792211?wid=1000&hei=1000&qlt=80&fmt=webp",
    "https://target.scene7.com/is/image/Target/GUEST_9dea9f04-9eb4-4c94-a16c-4995fbc3bad5?wid=1000&hei=1000&qlt=80&fmt=webp",
    ]
  },
  { id: "set64", name: "Holiday Night Spa",
    brand: "Medicube", category: "Skincare",
    stock: false, isSet: true, totPz: 3,ss:false, 
    price: 850, oldPrice: 0,
    fullSizeCount: 2, miniSizeCount: 1, dlxSizeCount: 0,
    descriptionSet: "Incluye Medicube Collagen Jelly Cream 50ml y PDRN Pink Collagen Gel Mask (2)",
    image: "https://target.scene7.com/is/image/Target/GUEST_bffb8c9a-a146-41ca-882d-d9690763c591?wid=1000&hei=1000&qlt=80&fmt=webp",
    setImages: [
    "https://target.scene7.com/is/image/Target/GUEST_bffb8c9a-a146-41ca-882d-d9690763c591?wid=1000&hei=1000&qlt=80&fmt=webp",
    "https://target.scene7.com/is/image/Target/GUEST_44ea4404-b807-4fc5-8aad-0d1ab4dc5d6f?wid=1000&hei=1000&qlt=80&fmt=webp",
    "https://target.scene7.com/is/image/Target/GUEST_4e2ec340-2e50-4363-b57e-e4a6700347f9?wid=1000&hei=1000&qlt=80&fmt=webp",
    ]
  },
  { id: "set65", name: "Big Lil Acne Treatment Sets",
    brand: "Starface", category: "Skincare",
    stock: false, isSet: true, totPz: 57, ss:false, 
    price: 800, oldPrice: 0,
    fullSizeCount: 1, miniSizeCount: 3, dlxSizeCount: 0,
    descriptionSet: "3 mini paquetes de parches & una cosmetiquera",
    image: "https://target.scene7.com/is/image/Target/GUEST_efd1df04-bdde-4611-859b-6c8a5fb33f06?wid=1000&hei=1000&qlt=80&fmt=webp",
    setImages: [
    "https://target.scene7.com/is/image/Target/GUEST_efd1df04-bdde-4611-859b-6c8a5fb33f06?wid=1000&hei=1000&qlt=80&fmt=webp",
    "https://target.scene7.com/is/image/Target/GUEST_f6eac82d-ed5a-4479-b8cd-a9f048ddc7e4?wid=1000&hei=1000&qlt=80&fmt=webp",
    "https://target.scene7.com/is/image/Target/GUEST_06c755ac-d93d-4370-9db8-72cddc7a0c6f?wid=1000&hei=1000&qlt=80&fmt=webp",
    ]
  },
  { id: "set66", name: "Frenchy Bears Keychain Set",
    brand: "Crém", category: "Perfumes",
    stock: false, isSet: true, totPz: 2,ss:false, 
    price: 820, oldPrice: 0,
    fullSizeCount: 2, miniSizeCount: 0, dlxSizeCount: 0,
    descriptionSet: "Llavero aleatorio coleccionable con body oil ",
    image: "https://target.scene7.com/is/image/Target/GUEST_c705843f-806f-47e1-a813-d239825bb2a7?wid=1000&hei=1000&qlt=80&fmt=webp",
    setImages: [
    "https://target.scene7.com/is/image/Target/GUEST_c705843f-806f-47e1-a813-d239825bb2a7?wid=1000&hei=1000&qlt=80&fmt=webp",
    "https://target.scene7.com/is/image/Target/GUEST_0d3c71ef-d877-478e-8a68-e000b40fba2e?wid=1000&hei=1000&qlt=80&fmt=webp",
    "https://target.scene7.com/is/image/Target/GUEST_ef828272-d736-485d-b6f8-759912f7240d?wid=1000&hei=1000&qlt=80&fmt=webp",
    ]
  },
  { id: "set67", name: "Petite Gourmand Mist Collection",
    brand: "Crémerie", category: "Perfumes",
    stock: false, isSet: true, totPz: 3, ss:false, 
    price: 860, oldPrice: 0,
    fullSizeCount: 0, miniSizeCount: 3, dlxSizeCount: 0,
    descriptionSet: "Mist de 30ml, aromas: Rose Macaron, Fleur de Vanille & Butter Croissant",
    image: "https://target.scene7.com/is/image/Target/GUEST_f40f9118-6084-4517-bbbd-a86e85074d8a?wid=1000&hei=1000&qlt=80&fmt=webp",
    setImages: [
    "https://target.scene7.com/is/image/Target/GUEST_f40f9118-6084-4517-bbbd-a86e85074d8a?wid=1000&hei=1000&qlt=80&fmt=webp",
    "https://target.scene7.com/is/image/Target/GUEST_0dad88e6-9b08-4d97-953a-bb293ce4340f?wid=1000&hei=1000&qlt=80&fmt=webp",
    ]
  },
  { id: "set68", name: "Prep + Plump Lab Kit",
    brand: "Byoma", category: "Variado",
    stock: false, isSet: true, totPz: 2,ss:false, 
    price: 520, oldPrice: 0,
    fullSizeCount: 1, miniSizeCount: 1, dlxSizeCount: 0,
    descriptionSet: "Incluye Liptide pH Lip Oil (5ml), Moisturizing Gel-Cream (15ml) + Lip Holder Keyring",
    image: "https://target.scene7.com/is/image/Target/GUEST_5976733e-f768-4e32-868c-ab7c5ac7e72d?wid=1000&hei=1000&qlt=80&fmt=webp",
    setImages: [
    "https://target.scene7.com/is/image/Target/GUEST_5976733e-f768-4e32-868c-ab7c5ac7e72d?wid=1000&hei=1000&qlt=80&fmt=webp",
    "https://target.scene7.com/is/image/Target/GUEST_d5ce5917-d15d-4dda-a5d1-a8b561fe5b7e?wid=1000&hei=1000&qlt=80&fmt=webp",
    ]
  },
  { id: "set69", name: "Express your e.l.f.",
    brand: "ELF", category: "Calendarios",
    stock: false, isSet: true, totPz: 24,ss:false, 
    price: 2880, oldPrice: 0,
    fullSizeCount: 18, miniSizeCount: 6, dlxSizeCount: 0,
    descriptionSet: "Calendario de 24 días de maquillaje y cuidado de la piel",
    image: "https://cdn.shopify.com/s/files/1/0661/2251/4520/files/Main_Image_Opt2.png?v=1791466212&width=2880&height=2880&crop=center",
    setImages: [
    "https://cdn.shopify.com/s/files/1/0661/2251/4520/files/Main_Image_Opt2.png?v=1791466212&width=2880&height=2880&crop=center",
    "https://cdn.shopify.com/s/files/1/0661/2251/4520/files/Supporting_Image_Fullsize.png?v=1791466212&width=720&height=720&crop=center",
    "https://cdn.shopify.com/s/files/1/0661/2251/4520/files/Supporting_Image_Mini.png?v=1791466212&width=1440&height=1440&crop=center",
    ]
  },
  { id: "set70", name: "Sugar Cookie Season",
    brand: "Sundae", category: "Variado",
    stock: false, isSet: true, totPz: 3,ss:false, 
    price: 830, oldPrice: 0,
    fullSizeCount: 3, miniSizeCount: 0, dlxSizeCount: 0,
    descriptionSet: "Shower Foam,esponja para baño y bomba de baño, aroma Sugar Cookie",
    image: "https://target.scene7.com/is/image/Target/GUEST_b93f1046-4ba4-4d2e-be2c-3dd9abf4e29c?wid=1000&hei=1000&qlt=80&fmt=webp",
    setImages: [
    "https://target.scene7.com/is/image/Target/GUEST_b93f1046-4ba4-4d2e-be2c-3dd9abf4e29c?wid=1000&hei=1000&qlt=80&fmt=webp",
    "https://target.scene7.com/is/image/Target/GUEST_cfd4d007-eff6-43c8-aff9-fd79fe1dc246?wid=1000&hei=1000&qlt=80&fmt=webp",
    ]
  },
  { id: "set71", name: "Haircare Travel + Body Set",
    brand: "Monday", category: "Variado",
    stock: false, isSet: true, totPz: 3,ss:false, 
    price: 450, oldPrice: 0,
    fullSizeCount: 0, miniSizeCount: 3, dlxSizeCount: 0,
    descriptionSet: "Incluye 3 minis para el cuidado del cuerpo y el cabello, además de ",
    image: "https://target.scene7.com/is/image/Target/GUEST_112960d4-b234-4be2-a86b-3c0793d1e383?wid=1000&hei=1000&qlt=80&fmt=webp",
    setImages: [
    "https://target.scene7.com/is/image/Target/GUEST_112960d4-b234-4be2-a86b-3c0793d1e383?wid=1000&hei=1000&qlt=80&fmt=webp",
    "https://target.scene7.com/is/image/Target/GUEST_2bcd6b91-d059-4b52-9ad3-9c410e1ee3c8?wid=1000&hei=1000&qlt=80&fmt=webp",
    ]
  },
  /*{ id: "set", name: "",
    brand: "", category: "",
    stock: false, isSet: true, totPz: 0,ss:false, 
    price: 0, oldPrice: 0,
    fullSizeCount: 0, miniSizeCount: 0, dlxSizeCount: 0,
    descriptionSet: "",
    image: "",
    setImages: [
    "",
    "",
    "",
    ]
  },
  { id: "set", name: "",
    brand: "", category: "",
    stock: false, isSet: true, totPz: 0,ss:false, 
    price: 0, oldPrice: 0,
    fullSizeCount: 0, miniSizeCount: 0, dlxSizeCount: 0,
    descriptionSet: "",
    image: "",
    setImages: [
    "",
    "",
    "",
    ]
  },
  { id: "set", name: "",
    brand: "", category: "",
    stock: false, isSet: true, totPz: 0,ss:false, 
    price: 0, oldPrice: 0,
    fullSizeCount: 0, miniSizeCount: 0, dlxSizeCount: 0,
    descriptionSet: "",
    image: "",
    setImages: [
    "",
    "",
    "",
    ]
  },
  { id: "set", name: "",
    brand: "", category: "",
    stock: false, isSet: true, totPz: 0,ss:false, 
    price: 0, oldPrice: 0,
    fullSizeCount: 0, miniSizeCount: 0, dlxSizeCount: 0,
    descriptionSet: "",
    image: "",
    setImages: [
    "",
    "",
    "",
    ]
  },
  { id: "set", name: "",
    brand: "", category: "",
    stock: false, isSet: true, totPz: 0,ss:false, 
    price: 0, oldPrice: 0,
    fullSizeCount: 0, miniSizeCount: 0, dlxSizeCount: 0,
    descriptionSet: "",
    image: "",
    setImages: [
    "",
    "",
    "",
    ]
  },
  { id: "set", name: "",
    brand: "", category: "",
    stock: false, isSet: true, totPz: 0,ss:false, 
    price: 0, oldPrice: 0,
    fullSizeCount: 0, miniSizeCount: 0, dlxSizeCount: 0,
    descriptionSet: "",
    image: "",
    setImages: [
    "",
    "",
    "",
    ]
  },
  { id: "set", name: "",
    brand: "", category: "",
    stock: false, isSet: true, totPz: 0,ss:false, 
    price: 0, oldPrice: 0,
    fullSizeCount: 0, miniSizeCount: 0, dlxSizeCount: 0,
    descriptionSet: "",
    image: "",
    setImages: [
    "",
    "",
    "",
    ]
  },
  { id: "set", name: "",
    brand: "", category: "",
    stock: false, isSet: true, totPz: 0,ss:false, 
    price: 0, oldPrice: 0,
    fullSizeCount: 0, miniSizeCount: 0, dlxSizeCount: 0,
    descriptionSet: "",
    image: "",
    setImages: [
    "",
    "",
    "",
    ]
  },
  { id: "set", name: "",
    brand: "", category: "",
    stock: false, isSet: true, totPz: 0,ss:false, 
    price: 0, oldPrice: 0,
    fullSizeCount: 0, miniSizeCount: 0, dlxSizeCount: 0,
    descriptionSet: "",
    image: "",
    setImages: [
    "",
    "",
    "",
    ]
  },*/
  { id: "set", name: "Hand Sanitizer Trio",
    brand: "V0", category: "Variado",
    stock: false, isSet: true, totPz: 3,ss:false, 
    price: 330, oldPrice: 0,
    fullSizeCount: 3, miniSizeCount: 0, dlxSizeCount: 0,
    descriptionSet: "Sanitizantes aromas Salted Caramel + Cozy Cashmere + Hazelnut Hot Chocolate",
    image: "https://target.scene7.com/is/image/Target/GUEST_e347bb2b-45cb-4cf7-9c02-d219b7cc000d?wid=1000&hei=1000&qlt=80&fmt=webp",
    setImages: [
    "https://target.scene7.com/is/image/Target/GUEST_e347bb2b-45cb-4cf7-9c02-d219b7cc000d?wid=1000&hei=1000&qlt=80&fmt=webp",
    "https://target.scene7.com/is/image/Target/GUEST_7697a892-3f54-4467-93ee-4805b27b6956?wid=1000&hei=1000&qlt=80&fmt=webp",
    ]
  },
  { id: "set", name: "Hand Sanitizer Trio",
    brand: "V0", category: "Variado",
    stock: false, isSet: true, totPz: 3,ss:false, 
    price: 330, oldPrice: 0,
    fullSizeCount: 3, miniSizeCount: 0, dlxSizeCount: 0,
    descriptionSet: "Sanitizantes aromas Vanilla Snowflake + Winter Berry + Cranberry Frost",
    image: "https://target.scene7.com/is/image/Target/GUEST_6ba387c4-f185-452c-8207-2544481788a4?wid=1000&hei=1000&qlt=80&fmt=webp",
    setImages: [
    "https://target.scene7.com/is/image/Target/GUEST_6ba387c4-f185-452c-8207-2544481788a4?wid=1000&hei=1000&qlt=80&fmt=webp",
    "https://target.scene7.com/is/image/Target/GUEST_181a930e-83b2-447d-969f-ce2beb0a7154?wid=1000&hei=1000&qlt=80&fmt=webp",
    ]
  },
  { id: "set", name: "Skincare Sets Remedy",
    brand: "Remedy", category: "Skincare",
    stock: false, isSet: true, totPz: 4,ss:false, 
    price: 820, oldPrice: 0,
    fullSizeCount: 1, miniSizeCount: 3, dlxSizeCount: 0,
    descriptionSet: "Rutina limpia, hidrata y trata, además incluye una bolsa acolchada",
    image: "https://target.scene7.com/is/image/Target/GUEST_5c3682e0-b38c-44ed-94d2-9c651a7e2506?wid=1000&hei=1000&qlt=80&fmt=webp",
    setImages: [
    "https://target.scene7.com/is/image/Target/GUEST_5c3682e0-b38c-44ed-94d2-9c651a7e2506?wid=1000&hei=1000&qlt=80&fmt=webp",
    "https://target.scene7.com/is/image/Target/GUEST_7ed3108b-7ad0-4893-9485-16b9101a1565?wid=1000&hei=1000&qlt=80&fmt=webp",
    "https://target.scene7.com/is/image/Target/GUEST_0e9d2982-f7b6-425f-90d1-74479187513e?wid=1000&hei=1000&qlt=80&fmt=webp",
    ]
  },
  { id: "set", name: "The Best of Glam Beauty Set",
    brand: "", category: "Variado",
    stock: false, isSet: true, totPz: 10,ss:false, 
    price: 850, oldPrice: 0,
    fullSizeCount: 0, miniSizeCount: 0, dlxSizeCount: 0,
    descriptionSet: "Marcas como: Nyx, Milani, Maybelline, Morphe & más",
    image: "https://target.scene7.com/is/image/Target/GUEST_e2da25a7-0ac1-445f-bd6e-fbf6aeab0b71?wid=1000&hei=1000&qlt=80&fmt=webp",
    setImages: [
    "https://target.scene7.com/is/image/Target/GUEST_e2da25a7-0ac1-445f-bd6e-fbf6aeab0b71?wid=1000&hei=1000&qlt=80&fmt=webp",
    "https://target.scene7.com/is/image/Target/GUEST_3f7a0450-eded-42e8-af03-aac348af0b60?wid=1000&hei=1000&qlt=80&fmt=webp",
    "https://target.scene7.com/is/image/Target/GUEST_9c7bcdf2-4e64-4cb5-a6a9-931773d8e69a?wid=1000&hei=1000&qlt=80&fmt=webp",
    ]
  },
  { id: "set", name: "6 Days of Kissmas Advent Calendar",
    brand: "Vitamasques", category: "Maquillaje",
    stock: false, isSet: true, totPz: 6,ss:false, 
    price: 860, oldPrice: 0,
    fullSizeCount: 3, miniSizeCount: 3, dlxSizeCount: 0,
    descriptionSet: "Incluye 3 bálsamos labiales Mini y 3 pares de parches metálicos para ojos.",
    image: "https://target.scene7.com/is/image/Target/GUEST_aada0061-9e61-4ba0-b0bf-74c6b9c7f7c4?wid=1000&hei=1000&qlt=80&fmt=webp",
    setImages: [
    "https://target.scene7.com/is/image/Target/GUEST_aada0061-9e61-4ba0-b0bf-74c6b9c7f7c4?wid=1000&hei=1000&qlt=80&fmt=webp",
    "https://target.scene7.com/is/image/Target/GUEST_e90642cb-c0b9-470f-852e-2be41fefa86d?wid=1000&hei=1000&qlt=80&fmt=webp",
    "https://target.scene7.com/is/image/Target/GUEST_0fca6d16-9370-4f05-8f13-1c096a50d311?wid=1000&hei=1000&qlt=80&fmt=webp",
    ]
  },

  { id: "set", name: "Best of Saie Mini Vanity Case Vault",
    brand: "Saie", category: "Variado",
    stock: false, isSet: true, totPz: 8 ,ss:true, 
    price: 4600, oldPrice: 4020,
    fullSizeCount: 6, miniSizeCount: 2, dlxSizeCount: 0,
    descriptionSet: "Incluye: Blush, Setting Spray, Mascara, Glossybounce, Super Gel y más",
    image: "https://www.sephora.com/productimages/sku/s3026309-av-3-zoom.jpg?imwidth=1224",
    setImages: [
      "https://www.sephora.com/productimages/sku/s3026309-av-3-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3026309-main-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3026309-av-2-zoom.jpg?imwidth=1224",
      "https://www.sephora.com/productimages/sku/s3026309-av-4-zoom.jpg?imwidth=1224"
    ]
  },

];